export default function CtaButton({ testid = "cta-button", className = "" }) {
  return (
    <a
      href="#anfrage"
      data-testid={testid}
      className={`inline-flex items-center justify-center rounded-[2px] bg-gruen px-9 py-4 text-xs font-semibold uppercase tracking-[0.12em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-gruenhover ${className}`}
    >
      Meine Zielgruppe prüfen lassen
    </a>
  );
}
